import API from './api'

export default {
	login(form) {
		const api = new API(1, 'users/login')

		return api.post(form)
	},
	resetPassword(email) {
		const api = new API(1, 'users/reset/request')

		return api.post({ email })
	},
	checkResetToken(token) {
		const api = new API(1, 'users/reset/check')

		return api.post({ token })
	},
	setPassword(token, password) {
		const api = new API(1, 'users/reset/process')

		return api.post({ token, password })
	},
	logout() {
		const api = new API(1, 'users/logout')

		api.get()
		.then(res => {
			localStorage.removeItem('tenant')
			localStorage.removeItem('userRole')
			if(process.env.NODE_ENV === 'production') {
				window.location.assign("https://app.yardonline.dev")
			} else {
				window.location.assign("http://app.yardonline.local")
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/lib/auth.js